import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService } from './layout/service/app.layout.service';
import { AuthentificationService } from './services/auth/authentification.service';
import { ActivationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { AppLayoutComponent } from './layout/app.layout.component';
import { NotificationService } from './services/notification/notification.service';
import { GlobalUtils } from "./utils/global-utils";
import { ApmServiceHandler } from './services/apm-handler.service';
import { TableUtils } from './utils/table-utils';
import {environment} from "../environments/environment";
import { ConfigurationService } from './services/configuration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Assure';
  timeoutActive : boolean = false;

  access = null;
  companyId: number;
  uuid: string;
  notifCount:any

  constructor(private cookies: CookieService, translate: TranslateService,private primengConfig: PrimeNGConfig, private layoutService: LayoutService, private router: Router,
    private authentificationService: AuthentificationService,private notificationService:NotificationService, apmServiceHandler: ApmServiceHandler, private configurationService: ConfigurationService) {
      apmServiceHandler.init();
    }



  async ngOnInit() {
    if(this.configurationService.get().displayChat) {
      this.loadUserlikeChat();
    }
    this.primengConfig.ripple = true;       //enables core ripple functionality

    //optional configuration with the default configuration
    this.layoutService.config = {
      ripple: true,                      //toggles ripple on and off
      inputStyle: 'outlined',             //default style for input elements
      menuMode: 'slim',                 //layout mode of the menu, valid values are "static", "overlay", "slim", "compact" and "horizontal"
      colorScheme: 'light',               //color scheme of the template, valid values are "light", "dim" and "dark"
      theme: 'indigo',                      //default component theme for PrimeNG, see theme section for available values
      menuTheme: "white",              //theme of the menu, see menu theme section for available values
      scale: 14                           //size of the body font size to scale the whole application
    };

    this.router.events.subscribe(event => {
      if (event instanceof ActivationStart) {
        let AppLayoutRouterTargetNode = this.router.config.filter(node => node != null && node?.component && node?.component instanceof Function
          && (node?.component as Function)?.name === AppLayoutComponent.name);
          this.timeoutActive = (AppLayoutRouterTargetNode && AppLayoutRouterTargetNode.length > 0 &&
          AppLayoutRouterTargetNode[0].children.filter(route => route?.component?.name == event?.snapshot?.component?.name).length > 0)
      }
    });
    this.primengConfig.setTranslation(GlobalUtils.initCalendar());
    this.primengConfig.setTranslation(TableUtils.pColumnFilterTranslate());

  }

  private loadUserlikeChat(): void {
    if (document.getElementById('userlike-script')) return;
    const script = document.createElement('script');
    script.id = 'userlike-script';
    script.src = "https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/105289d63411d0e1ffe161c19cda6c3fe4cb6d86b41e133911e8524d0cbc4d37.js";
    script.async = true;
    document.body.appendChild(script);
  }

}

